import { PERMISSION_CATALOG_VERSION, SPECIAL_PERMISSIONS, type EffectivePermissions } from '@till-erp/platform/permissions';
import { createContext, useContext, useMemo } from 'react';
import type { Me, TokenGetter } from './api.ts';
import type { AuthClient } from './auth.ts';

export interface Session {
  me: Me;
  auth: AuthClient;
  getToken: TokenGetter;
  /** Neuer Stand der angemeldeten Person (z. B. nach dem Speichern im Profil). */
  updateMe: (me: Me) => void;
}

export const SessionContext = createContext<Session | null>(null);

export function useSession(): Session {
  const s = useContext(SessionContext);
  if (!s) throw new Error('useSession außerhalb der Anmeldung');
  return s;
}

/** Browseranzeige verwendet ausschließlich die Rechte aus /me; fehlende Angaben sperren. */
export function sessionPermissions(me: Me): EffectivePermissions {
  return { catalogVersion: PERMISSION_CATALOG_VERSION, keys: me.access?.permissions ?? [], scopes: me.access?.scopes ?? {}, knownScopes: Object.fromEntries(SPECIAL_PERMISSIONS.map((special) => [special.key, Object.keys(special.scopes)])) };
}

/** Wirksame Rechte der angemeldeten Person (gleicher Wert, solange `me` gleich bleibt). */
export function useSessionPermissions(): EffectivePermissions {
  const { me } = useSession();
  return useMemo(() => sessionPermissions(me), [me]);
}
